import { render } from "./contact_body_main.vue?vue&type=template&id=21ea5384&scoped=true"
import script from "./contact_body_main.vue?vue&type=script&lang=js"
export * from "./contact_body_main.vue?vue&type=script&lang=js"

import "./contact_body_main.vue?vue&type=style&index=0&id=21ea5384&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21ea5384"]])

export default __exports__